import React from "react";
import { useNavigate } from 'react-router-dom';
import { useCart } from '../../context/cartcontext.js';
import '../../styles/products/body_cart.css';

function Body_cart() {
    const { cart, cartTotal, removeFromCart, updateQuantity } = useCart();
    const navigate = useNavigate();

    if (!Array.isArray(cart) || cart.length === 0) {
        return <p className="empty-message">Ihr Warenkorb ist leer!</p>;
    }

    return (
        <section className="warenkorb">
            <h2>🛒 Warenkorb</h2>

            {cart.map((item, index) => (
                <div key={`${item.id}-${item.image}-${index}`} className="cart-item">
                    <img src={item.image} alt={item.name} className="cart-image" />
                    <div className="cart-info">
                        <p className="cart-name">{item.name}</p>
                        <label className="cart-name">
                            Stückzahl:
                            <select
                                value={item.quantity}
                                onChange={(e) =>
                                    updateQuantity(item.id, item.image, parseInt(e.target.value))
                                }
                            >
                                <option value={0}>0 (Entfernen)</option>
                                {[...Array(10).keys()].map((num) => (
                                    <option key={num + 1} value={num + 1}>
                                        {num + 1}
                                    </option>
                                ))}
                            </select>
                        </label>
                        <p>Einzelpreis: {parseFloat(item.price).toFixed(2)} €</p>
                        <p>Gesamt: {(parseFloat(item.price) * item.quantity).toFixed(2)} €</p>
                        <button
                            className="remove-button"
                            onClick={() => removeFromCart(item.id, item.image)}
                        >
                            ❌ Entfernen
                        </button>
                    </div>
                </div>
            ))}

            <h3 className="cart-total">Gesamtsumme: {cartTotal.toFixed(2)} €</h3>

            <div className="payment-methods">
                <div className="payment-buttons">
                    <button className="pay-button bank" onClick={() => navigate('/kasse')}>
                        Zur Kasse
                    </button>
                </div>
            </div>
        </section>
    );
}

export default Body_cart;
